export default __webpack_public_path__ + "static/media/5.c80c0800.png";